import { SentMessageReducerState } from './types';

export const selectSentMessage = (state: SentMessageReducerState) => state.sentMessage.sentMessage;
export const selectIsFetchingSentMessage = (state: SentMessageReducerState) =>
  state.sentMessage.isFetchingSentMessage;
